import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import { config } from '../ts/config';
import DirsTreeFlat, { calculateSelectAllState, DirsTreeModes, IContentItems } from './DirsTreeFlat';
import DirsTemplatesItem from './DirsTemplatesItem';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import { ITemplatesDirsInstanceState } from '../ts/stores/TemplatesDirsStore';
import { IMarkedItems } from '../ts/Interfaces';

export default class DirsTemplatesFlat extends React.Component<
    {
        instanceID: string;
        markMode?: boolean;
        markedDirs?: IMarkedItems;
        markedTemplates?: IMarkedItems;
        glob: IGlob;

        onDirSelect?(id: number): void;
        onTemplatesMark?(value: IMarkedItems): void;
        onDirsMark?(value: IMarkedItems): void;
        onMark?(dirs: IMarkedItems, content: IMarkedItems): void;
    },
    {
        displayDirID?: number;
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            displayDirID: config.TEMPLATES_ROOT_DIR_ID
        };
    }

    static defaultProps = {
        instanceID: config.WIDGETS_ROOT_DIR_ID.toString()
    };

    componentDidMount() {
        this.props.glob.TemplatesDirsStore.addChangeListener(this.handleOnStoreChange);

        this.props.glob.AppActions.templatesExplorerClear(this.props.instanceID);
        this.props.glob.AppActions.templatesExplorerSingleLoad(this.state.displayDirID, this.props.instanceID);
    }

    componentWillUnmount() {
        this.props.glob.TemplatesDirsStore.removeChangeListener(this.handleOnStoreChange);
    }

    handleOnStoreChange = () => {
        this.setState(this.state);
    };

    handleDirSelect = (id: number) => {
        this.setState({ displayDirID: id }, () => {
            this.props.glob.AppActions.templatesExplorerSingleLoad(id, this.props.instanceID);

            if (typeof this.props.onDirSelect === 'function') {
                this.props.onDirSelect(id);
            }
        });
    };

    // handleItemAdd = () => {
    //     this.props.glob.AppActions.templateShow(null);
    //     this.props.glob.AppActions.templateCreateNew(this.state.displayDirId);
    // };

    // Select parent if self item deleted
    handleItemDelete = (id: number) => {
        if (id === this.state.displayDirID) {
            const instanceState = this.props.glob.DirsStore.getInstanceState(this.props.instanceID);

            if (instanceState != null) {
                const dirObj = instanceState.data.dirsHash[id];
                const parentId = dirObj.parent.dirid;

                this.handleDirSelect(parentId);
            }
        }
    };

    getOnMarkHandler(id: number, name: string) {
        return (value: boolean) => {
            const marked = _.clone(this.props.markedTemplates);

            if (value) {
                marked[id] = name;
            } else {
                delete marked[id];
            }

            if (typeof this.props.onTemplatesMark === 'function') {
                this.props.onTemplatesMark(marked);
            }
        };
    }

    getView(instance: ITemplatesDirsInstanceState) {
        const { dirContent, rename, renameLoading } = instance;

        if (dirContent == null || dirContent.length === 0) {
            return;
        }

        return (
            <ul className="list-unstyled dirs-list-templates-flat">
                {_.map(dirContent, (item, i) => {
                    if (item.data == null) {
                        return;
                    }

                    const { wtid } = item;

                    return (
                        <li key={i}>
                            <DirsTemplatesItem
                                key={wtid}
                                wtid={wtid}
                                instanceID={this.props.instanceID}
                                data={item.data}
                                name={item.name}
                                displayDirID={this.state.displayDirID}
                                markMode={this.props.markMode}
                                marked={this.props.markMode && this.props.markedTemplates?.[wtid] !== undefined}
                                dragDropData={{
                                    scope: 'workspace',
                                    itemType: 'template'
                                }}
                                rename={rename}
                                renameLoading={renameLoading}
                                glob={this.props.glob}
                                onMarkedChange={this.getOnMarkHandler(wtid, item.name)}
                            />
                        </li>
                    );
                })}
            </ul>
        );
    }

    processDirsMark = (obj: IMarkedItems) => {
        if (typeof this.props.onDirsMark === 'function') {
            this.props.onDirsMark(obj);
        }
    };

    getContentKeys(): IContentItems {
        const dirs: IMarkedItems = {};
        const templates: IMarkedItems = {};
        const contentData = this.props.glob.TemplatesDirsStore._state.data[this.props.instanceID];

        // let content = _.pluck(contentData && contentData.dirContent, 'wtid');

        // content = _.map(content, function (id) {
        //     return id.toString();
        // });

        const dirsData = this.props.glob.DirsStore._state.data[this.props.instanceID];
        const dirsHash = dirsData && dirsData.data && dirsData.data.dirsHash;

        // let dirs = _.map(
        //     _.pluck(
        //         dirsHash && dirsHash[this.state.displayDirID] && dirsHash[this.state.displayDirID].subdirlist,
        //         'dirid'
        //     ),
        //     (id) => {
        //         return id.toString();
        //     }
        // );

        if (dirsHash != null) {
            const { displayDirID } = this.state;
            const item = dirsHash[displayDirID as number];

            if (item != null) {
                _.each(item.subdirlist, (item) => {
                    if (item.dirid != null) {
                        dirs[item.dirid.toString()] = item.name;
                    }
                });
            }

            if (contentData?.dirContent != null) {
                _.each(contentData.dirContent, (item) => {
                    if (item.wtid != null) {
                        templates[item.wtid.toString()] = item.name;
                    }
                });
            }
        }

        return {
            dirs: dirs,
            items: templates
        };
    }

    getSelectAllState = () => {
        const content = this.getContentKeys();

        return calculateSelectAllState(content, this.props.markedDirs, this.props.markedTemplates);
    };

    handleOnSelectAllChange = (value: boolean) => {
        if (typeof this.props.onMark === 'function') {
            if (value) {
                const content = this.getContentKeys();

                this.props.onMark(content.dirs, content.items);
            } else {
                this.props.onMark({}, {});
            }
        }
    };    

    getContentLengthHandler() {
        return (dirID: number) => {
            const result = $.Deferred<number>();

            this.props.glob.TemplatesDirsStore.getDirContent(dirID).done((resp) => {
                if (resp != null) {
                    result.resolve(resp.result.length);
                }
            });

            return result;
        };
    }

    render() {
        const instance = this.props.glob.TemplatesDirsStore.getInstanceState(this.props.instanceID);

        let content: React.JSX.Element;

        if (instance.loading) {
            content = <ProgressBar />;
        } else {
            content = this.getView(instance);
        }

        return (
            <div className={'dirs-flat dirs-templates-flat' + (instance.loading ? ' loading' : '')}>
                <DirsTreeFlat
                    instanceId={this.props.instanceID}
                    mode={DirsTreeModes.TEMPLATE_SELECT}
                    rootId={config.TEMPLATES_ROOT_DIR_ID}
                    rootName={config.TEMPLATES_ROOT_DIR_NAME}
                    displayId={this.state.displayDirID}
                    canEdit={true}
                    showSelectAll={this.props.markMode}
                    markMode={this.props.markMode}
                    marked={this.props.markedDirs}
                    getContentLength={this.getContentLengthHandler()}
                    getSelectAllState={this.getSelectAllState}
                    glob={this.props.glob}
                    onSelect={this.handleDirSelect}
                    //onItemAdd={ this.handleItemAdd }
                    onItemDelete={this.handleItemDelete}
                    onMark={this.processDirsMark}
                    onSelectAllChange={this.handleOnSelectAllChange}
                />

                {content}
            </div>
        );
    }
}
